import { all, fork } from 'redux-saga/effects';

import watchHotsiteRequest from './hotsiteRequest';

function* hotsiteSagas() {
  yield all([fork(watchHotsiteRequest)]);
}

export default hotsiteSagas;
